"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseIcons = require("nicbase-icons");

var _baseMarker = _interopRequireDefault(require("../base-marker"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AssetClusterMarker = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var lat = _ref.lat,
      lng = _ref.lng,
      pointCount = _ref.pointCount,
      onClick = _ref.onClick;
  var clusterColor = (0, _classnames["default"])({
    'bg-primary fill-primary': pointCount < 50,
    'bg-yellow-500 fill-yellow-500': pointCount >= 50 && pointCount < 150,
    'bg-red-500 fill-red-500': pointCount >= 150
  });
  return /*#__PURE__*/_react["default"].createElement(_baseMarker["default"], {
    lat: lat,
    lng: lng,
    zIndex: 10
  }, /*#__PURE__*/_react["default"].createElement("div", {
    role: "button",
    tabIndex: 0,
    className: (0, _classnames["default"])('p-1 rounded outline-none shadow hover:shadow-md focus:ring flex items-center text-white font-bold text-sm', clusterColor),
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Asset, {
    className: "fill-white h-4 w-4"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "mx-1"
  }, pointCount)));
});

AssetClusterMarker.propTypes = _objectSpread(_objectSpread({}, _baseMarker["default"].propTypes), {}, {
  pointCount: _propTypes["default"].number,
  onClick: _propTypes["default"].func
});

var noop = function noop() {};

AssetClusterMarker.defaultProps = {
  pointCount: 0,
  onClick: noop
};
var _default = AssetClusterMarker;
exports["default"] = _default;